<template>
  <v-container class="top-spacer">
    <div class="component-title">Dashboard</div>
    <v-row>
      <v-col cols="12">
        <!-- Apposta Statistics -->
        <v-row>
          <v-col cols="12">
            <div class="card-label">Estatísticas APPosta</div>
            <AppostaCard
              v-if="loaded"
              :userStats="userStats"
              :isComponent="true"
            ></AppostaCard>
          </v-col>
        </v-row>
        <!-- User Statistics -->
        <v-row>
          <v-col cols="12">
            <div class="card-label">Estatísticas utilizadores</div>
            <v-card style="padding: 0 24px">
              <v-row>
                <v-col>
                  <v-row class="statistics-row">
                    <v-col>
                      <div class="gray-label">Registados</div>
                      <div class="black-value" v-if="userStats.registered">
                        {{
                          userStats.registered[0]
                            ? userStats.registered[0].count
                            : 0
                        }}
                      </div>
                    </v-col>
                    <v-col>
                      <div class="gray-label">Free</div>
                      <div class="black-value" v-if="userStats.free">
                        {{ userStats.free[0] ? userStats.free[0].count : 0 }}
                      </div>
                    </v-col>
                    <v-col
                      v-for="(stats, index) in userStats.subscriptionStats"
                      :key="'stats-' + index"
                    >
                      <div
                        class="gray-label"
                        style="text-transform: capitalize"
                      >
                        {{ stats.app + " " + stats.paymentType }}
                      </div>
                      <div class="black-value">{{ stats.count }}</div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <!-- Bigometro Bigodds -->
          <v-col class="dashboard-col">
            <div class="card-label">Bigometro Bigodds</div>
            <BigometroCard :isComponent="true"></BigometroCard>
          </v-col>
          <!-- Controlo Mensal -->
          <v-col class="dashboard-col">
            <div class="card-label">Controlo mensal Bigodds</div>
            <BigometroTable :tableData="tableData"></BigometroTable>
          </v-col>
        </v-row>
        <!-- Tiro Certeiro a Decorrer -->
        <v-row>
          <v-col>
            <div class="card-label">Tiro Certeiro a Decorrer</div>
            <BackofficeTiroCerteiroCard
              v-if="loaded"
              :tiroCerteiro="current"
              @edit="editItem(current)"
              @delete="deleteItem(current)"
            ></BackofficeTiroCerteiroCard>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.statistics-row .col,
.tiro-certeiro-row .col {
  padding: 4px 12px 0 12px;
}
.gray-label {
  font-family: Gilroy-SemiBold;
  font-size: 10px;
  line-height: 16px;
  color: #bcc5cc;
}
.tiro-certeiro-row .col .gray-label:nth-child(3) {
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  line-height: 14px;
  color: #6d818f;
}
.black-value {
  font-family: Gilroy-Medium;
  color: #304351;
}
.statistics-row .black-value {
  font-size: 36px;
  line-height: 48px;
}
.tiro-certeiro-row .black-value {
  font-size: 14px;
  line-height: 16px;
}
.dashboard-col {
  flex: 0 0 50%;
  max-width: 50%;
}
@media only screen and (max-width: 1024px) {
  .dashboard-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media only screen and (max-width: 768px) {
  .top-spacer {
    padding-top: 64px !important;
  }
  .statistics-row .col {
    flex: 0 0 33%;
    max-width: 33%;
  }
}
</style>

<script>
import AppostaCard from "@/components/AppostaCard.vue";
import BigometroCard from "@/components/BigometroCard.vue";
import BigometroTable from "@/components/BigometroTable.vue";
import BackofficeTiroCerteiroCard from "@/components/backoffice/BackofficeTiroCerteiroCard.vue";

import ApiService from "@/services/api.service";
import DateTimeService from "@/services/datetime.service";

export default {
  name: "BackofficeDashboard",
  components: {
    AppostaCard,
    BigometroCard,
    BigometroTable,
    BackofficeTiroCerteiroCard,
  },
  data: () => ({
    tableData: [],
    current: {},
    userStats: {},
    loaded: false,
    labels: [],
  }),
  created() {
    this.getRanking();
  },
  methods: {
    getRanking() {
      ApiService.getGraphQLUserStatsCurrentTiroCerteiro().then(
        (response) => {
          const data = response.data.data;
          this.current = data.getCurrentTiroCerteiro;
          this.userStats = data.getUserStats;
          console.log(this.userStats);
          this.loaded = true;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    }
  }
};
</script>
